// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1iE-t","approved":"Status_approved__1OODN","rejected":"Status_rejected__3OaY8","expired":"Status_expired__1e9h-","label":"Status_label__3UfKt"};